import { MBase } from "./MBase";
import * as moment from 'moment';

export class Cultivar extends MBase {
    Descricao:string = "";
    EmpresaId: number;
    CulturaId: number;
    CultivarBaseId: number;
    Unidade:string = "";
    Obtentor:string = "";
    Ciclo: number = 0;
    PesoMilSemente: number = 0;
    Germinacao: number = 0;
    Vigor: number = 0;
    IdERP:string = "";
    Ativo = true; // default
    UsuarioAlteracaoDesc: string

    get descAtivo(): string{
      return this.Ativo ? 'Ativo' : 'Inativo'
    }

    get dataAlteracaoStr(): string{
      return moment(this.DataAlteracao).format('DD/MM/YYYY HH:mm')
    }
}
